@if (inited) {
    <div class="height100p flex-col-fixed-fill">
        <sm-toolbar>
            <p-button icon="fas fa-save" label="Speichern" [disabled]="!isChanged()" (onClick)="save()">
            </p-button>
        </sm-toolbar>
        <sm-table [data]="table">
        </sm-table>
    </div>
}